const MARKETPLACE_PRESTASHOP_MIN_VERSION = [1, 0, 4];

function capabilityEnabled(capabilities, camelCaseKey, snakeCaseKey) {
  return capabilities?.[camelCaseKey] === true || capabilities?.[snakeCaseKey] === true;
}

function parseVersion(value) {
  const match = String(value || '').trim().replace(/^v/i, '').match(/^(\d+)\.(\d+)\.(\d+)/);
  return match ? match.slice(1).map(Number) : null;
}

function versionAtLeast(version, minimum) {
  if (!version) return false;
  for (let index = 0; index < minimum.length; index += 1) {
    if (version[index] > minimum[index]) return true;
    if (version[index] < minimum[index]) return false;
  }
  return true;
}

/**
 * Marketplace PrestaShop modules have supported the complete bridge-backed
 * admin and artifacts.publish contract since 1.0.4. Versions before the
 * explicit shared_admin_runtime_v1 handshake therefore need a compatibility
 * projection instead of being treated as unsupported.
 */
export function hasMarketplacePluginContract({ platform, moduleVersion, capabilities = {} }) {
  const normalizedPlatform = String(platform || '').trim().toLowerCase();
  return normalizedPlatform === 'prestashop'
    && versionAtLeast(parseVersion(moduleVersion), MARKETPLACE_PRESTASHOP_MIN_VERSION)
    && capabilityEnabled(capabilities, 'operatorStateV1', 'operator_state_v1')
    && capabilityEnabled(capabilities, 'onboardingCheckpointsV1', 'onboarding_checkpoints_v1')
    && capabilityEnabled(capabilities, 'publishStateV1', 'publish_state_v1');
}

export function supportsPluginArtifactMutation({ platform, moduleVersion, capabilities = {} }) {
  return capabilityEnabled(capabilities, 'sharedAdminRuntimeV1', 'shared_admin_runtime_v1')
    || hasMarketplacePluginContract({ platform, moduleVersion, capabilities });
}

export function hasMarketplacePluginBridgeShape(response) {
  const state = response?.state && typeof response.state === 'object'
    ? response.state
    : response;
  const context = state?.context || {};
  const capabilities = state?.capabilities || {};

  return String(context.platform || '').trim().toLowerCase() === 'prestashop'
    && capabilityEnabled(capabilities, 'operatorStateV1', 'operator_state_v1')
    && capabilityEnabled(capabilities, 'onboardingCheckpointsV1', 'onboarding_checkpoints_v1')
    && capabilityEnabled(capabilities, 'publishStateV1', 'publish_state_v1');
}

export function supportsPluginArtifactMutationResponse(response) {
  const state = response?.state && typeof response.state === 'object'
    ? response.state
    : response;
  const context = state?.context || {};

  return supportsPluginArtifactMutation({
    platform: context.platform,
    moduleVersion: context.moduleVersion || context.module_version,
    capabilities: state?.capabilities || {},
  });
}
